import { render, staticRenderFns } from "./DeviceList.vue?vue&type=template&id=1668affa&scoped=true"
import script from "./DeviceList.vue?vue&type=script&lang=js"
export * from "./DeviceList.vue?vue&type=script&lang=js"
import style0 from "./DeviceList.vue?vue&type=style&index=0&id=1668affa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1668affa",
  null
  
)

export default component.exports